import { PartialTenantCustomizations } from "src/tenantCustomizations/TenantCustomizations";
import { getRandomValueSamplingMethod } from "src/tenantCustomizations/tenants/demo1/spcSamplingMethods/randomValueSamplingMethod.tsx";
import {
	getInventoryLevelEventQuantitySpcSamplingMethod,
	getInventoryLevelEventTotalWeightSpcSamplingMethod,
} from "src/components/views/erp/spcSamplingMethods/inventoryLevelEventSpcSamplingMethods.tsx";
import { getCumulativeRecordSamplingMethod } from "src/components/views/spc/commonSamplingMethods/cumulativeRecordSamplingMethod.tsx";
import { defaultSpcSamplingMethods } from "src/tenantCustomizations/defaultTenantCustomizations.ts";

export const demo1Customizations: PartialTenantCustomizations = {
	tenantConfig: {
		erp: {
			enabled: true,
			crmEnabled: true,
			customerOrderCheckingEnabled: true,
			reclamationsEnabled: true,
			configuratorEnabled: true,
			projectActivitySchedulingEnabled: true,
			surveysEnabled: true,
			reclamationRoundPlanningAiEnabled: true,
			winnerIntegrationEnabled: true,
			transportPlanningEnabled: true,
			deliveryPackageBundlingEnabled: true,
			projectActivityMaterialImportMethods: ["STANDARD_TABULAR", "VERTEX", "SOLIDWORKS", "WINNER"],
			customerOfferLineImportMethods: ["STANDARD_TABULAR", "VERTEX"],
			customerOrderLineImportMethods: ["STANDARD_TABULAR", "VERTEX"],
			vectorEmbeddingsEnabled: true,
			accountingIntegrationEnabled: true,
		},
		spc: {
			processImprovementsEnabled: true,
		},
		tasks: {
			enabled: true,
		},
		documentsEnabled: true,
		workspacesEnabled: true,
	},
	erp: {
		production: {
			addShopOrdersToBatchView: {
				configuratorFilterComponents: [
					{ componentUuid: "6a146274-4234-427a-bb7b-4c4b1d82ad5c" },
					{ componentUuid: "51d55ab3-91b0-42f8-809f-a4b8884138e6" },
				],
			},
		},
	},
	spcSamplingMethods: () => [
		...defaultSpcSamplingMethods,
		getInventoryLevelEventQuantitySpcSamplingMethod(),
		getInventoryLevelEventTotalWeightSpcSamplingMethod(),
		getRandomValueSamplingMethod(),
		getCumulativeRecordSamplingMethod(),
	],
} as const;
